import { QarepaEnumInformation } from '@qarepa/common';

export enum AbsenceUnitEnum {
  DAYS = 'DAYS',
  HOURS = 'HOURS',
  WEEKS = 'WEEKS',
}

export type AbsenceUnitType =
  AbsenceUnitEnum.DAYS | AbsenceUnitEnum.HOURS | AbsenceUnitEnum.WEEKS;

export const AbsenceUnitArray = [
  AbsenceUnitEnum.DAYS,
  AbsenceUnitEnum.HOURS,
  AbsenceUnitEnum.WEEKS,
];

export const AbsenceUnitInfo: QarepaEnumInformation<AbsenceUnitEnum> = {
  [AbsenceUnitEnum.DAYS]: {
    name: $localize`Días`,
  },
  [AbsenceUnitEnum.HOURS]: {
    name: $localize`Horas`,
  },
  [AbsenceUnitEnum.WEEKS]: {
    name: $localize`Semanas`,
  },
};
